import { render, staticRenderFns } from "./TicketErfassen.vue?vue&type=template&id=80fde2dc&scoped=true"
import script from "./TicketErfassen.vue?vue&type=script&lang=js"
export * from "./TicketErfassen.vue?vue&type=script&lang=js"
import style0 from "./TicketErfassen.vue?vue&type=style&index=0&id=80fde2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fde2dc",
  null
  
)

export default component.exports